/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import CalculateIcon from "@mui/icons-material/Calculate";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import PersonIcon from "@mui/icons-material/Person";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import Collapse from "@mui/material/Collapse";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useNavigate } from "react-router-dom";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import BuildIcon from "@mui/icons-material/Build";
import SettingsIcon from "@mui/icons-material/Settings";
import AccountBalanceIcon from "@mui/icons-material/RequestQuote";

import * as React from "react";
import { Select, MenuItem } from "@mui/material";
import { useAuthState } from "react-firebase-hooks/auth";

import { useEffect, useState } from "react";
import "./style.css";
import "./style.scss";

// react-router-dom components
import { NavLink, useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";
import Link from "@mui/material/Link";
import List from "@mui/material/List";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import SidenavCollapse from "examples/Sidenav/SidenavCollapse";

// Custom styles for the Sidenav
import SidenavRoot from "examples/Sidenav/SidenavRoot";
import sidenavLogoLabel from "examples/Sidenav/styles/sidenav";
import { LanguageContext } from "App";
import { UserContext } from "App";
import { getAuth, signOut } from "firebase/auth";
import { useContext } from "react";
// Material Dashboard 2 React context
import {
  setMiniSidenav,
  setTransparentSidenav,
  setWhiteSidenav,
  useMaterialUIController,
} from "context";
import BrandingTheme from "BrandingTheme";
import zIndex from "@mui/material/styles/zIndex";
import UsersApi from "Classes/API/UsersApi";
import TenantManager from "Classes/API/TenantManager";
import { jwtDecode } from "jwt-decode";
import TenantsApi from "Classes/API/Administration/TenantsApi";
import { useTenant } from "../../context/TenantContext";

function Sidenav({ color, brand, brandName, routes, ...rest }) {
  const auth = getAuth();
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    transparentSidenav,
    whiteSidenav,
    darkMode,
    sidenavColor,
  } = controller;
  const location = useLocation();
  const collapseName = location.pathname.replace("/", " ");
  const User = useContext(UserContext);
  const createMultiPackagePath =
    "/Accountingsessions/Packages/CreateMultiPackage";
  const { translations, switchLanguage } = useContext(LanguageContext);
  const [language, setLanguage] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  // Use the tenant hook
  const { tenants, currentTenant, isSuperAdmin, switchTenant } = useTenant();

  const tenantId = currentTenant?.id;

  const [selectedTenant, setSelectedTenant] = useState(null);
  const [user, loading, error] = useAuthState(auth);
  const [branding, setBRanding] = useState();

  const LanguageDropdown = ({ language, setLanguage, sidenavColor }) => {
    const handleLanguageChange = (event) => {
      setLanguage(event.target.value);
    };
  };

  useEffect(() => {
    const setupBranding = async () => {
      if (user) {
        setBRanding(new BrandingTheme(tenantId));
      }
    };
    setupBranding();
  }, [user, tenantId]);

  const handleSubmit = async () => {
    if (!selectedTenant) {
      console.error("No tenant selected!");
      return;
    }
    await switchTenant(selectedTenant);
  };

  let textColor = "white";

  const Logout = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        <Navigate to="/" />;
      })
      .catch((error) => {
        // An error happened.
      });
  };
  const handleLanguageChange = (event) => {
    const selectedLanguage = event.target.value;
    setLanguage(selectedLanguage);
    switchLanguage(selectedLanguage);
  };

  if (transparentSidenav || (whiteSidenav && !darkMode)) {
    textColor = "dark";
  } else if (whiteSidenav && darkMode) {
    textColor = "inherit";
  }
  const childRoutes5 = [
    "/Appointments/Feedback",
    "/Appointments/FeedbackStatistics",
    "/Appointments/UserStatistics",
    "/Appointments/AccountingSessionsStatistics",
    "/Appointments/AccountingEntriesStatistics",
  ];
  useEffect(() => {
    if (childRoutes5.includes(location.pathname)) {
      setOpen5(true);
    }
  }, [location.pathname]);
  const childRoutes2 = [
    "/Appointments",
    "/PatientPrograms/CreatePatientProgram",
    "/ManagePatientPrograms",
    "/Appointments/PatientAppointmentRequests",
  ];
  useEffect(() => {
    if (childRoutes2.includes(location.pathname)) {
      setOpen2(true);
    }
  }, [location.pathname]);
  const childRoutes3 = [
    "/Accountingsessions",
    "/CreateInPatientStay",
    "/CreateContract",
    "/CreatePackage",
  ];
  useEffect(() => {
    if (childRoutes3.includes(location.pathname)) {
      setOpen3(true);
    }
  }, [location.pathname]);
  const childRoutes0 = ["/PatientHistory", "/CreateUser"];
  useEffect(() => {
    if (childRoutes0.includes(location.pathname)) {
      setOpen0(true);
    }
  }, [location.pathname]);
  const closeSidenav = () => setMiniSidenav(dispatch, true);

  const [open0, setOpen0] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [open3, setOpen3] = React.useState(false);
  const [open5, setOpen5] = React.useState(false);
  const [open6, setOpen6] = React.useState(false);
  const [open7, setOpen7] = React.useState(false);

  const handleClick = () => {
    setOpen0(false);
    setOpen(!open);
    setOpen2(false);
    setOpen3(false);
    setOpen5(false);
    setOpen6(false);
    setOpen7(false);
  };
  const handleClick2 = () => {
    setOpen0(false);
    setOpen(false);
    setOpen2(!open2);
    setOpen3(false);
    setOpen5(false);
    setOpen6(false);
    setOpen7(false);
  };
  const handleClick3 = () => {
    setOpen0(false);
    setOpen(false);
    setOpen2(false);
    setOpen5(false);
    setOpen6(false);
    setOpen7(false);
    setOpen3(!open3);
  };
  const handleClick0 = () => {
    setOpen(false);
    setOpen2(false);
    setOpen3(false);
    setOpen5(false);
    setOpen6(false);
    setOpen7(false);
    setOpen0(!open0);
  };

  const handleClick5 = () => {
    setOpen(false);
    setOpen2(false);
    setOpen3(false);
    setOpen0(false);
    setOpen6(false);
    setOpen7(false);
    setOpen5(!open5);
  };
  const handleClick6 = () => {
    setOpen(false);
    setOpen2(false);
    setOpen3(false);
    setOpen0(false);
    setOpen5(false);
    setOpen7(false);
    setOpen6(!open6);
  };
  const handleClick7 = () => {
    setOpen(false);
    setOpen2(false);
    setOpen3(false);
    setOpen0(false);
    setOpen5(false);
    setOpen6(false);
    setOpen7(!open7);
  };

  useEffect(() => {
    const storedLanguage = localStorage.getItem("language");
    if (storedLanguage) {
      setLanguage(storedLanguage);
    }
  }, []);
  useEffect(() => {
    // A function that sets the mini state of the sidenav.
    function handleMiniSidenav() {
      setMiniSidenav(dispatch, window.innerWidth < 1200);
      setTransparentSidenav(
        dispatch,
        window.innerWidth < 1200 ? false : transparentSidenav,
      );
      setWhiteSidenav(
        dispatch,
        window.innerWidth < 1200 ? false : whiteSidenav,
      );
    }

    /** 
     The event listener that's calling the handleMiniSidenav function when resizing the window.
    */
    window.addEventListener("resize", handleMiniSidenav);
    // Call the handleMiniSidenav function to set the state with the initial value.
    handleMiniSidenav();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleMiniSidenav);
  }, [dispatch, location]);

  // Render all the routes from the routes.js (All the visible items on the Sidenav)
  const renderRoutes = routes.map(
    ({ type, name, icon, title, noCollapse, key, href, route }) => {
      let returnValue;

      if (type === "collapse") {
        returnValue = href ? (
          <Link
            href={href}
            key={key}
            target="_blank"
            rel="noreferrer"
            sx={{ textDecoration: "none" }}
          >
            <SidenavCollapse
              name={name}
              icon={icon}
              active={key === collapseName}
              noCollapse={noCollapse}
            />
          </Link>
        ) : (
          <NavLink key={key} to={route}>
            <SidenavCollapse
              name={name}
              icon={icon}
              active={key === collapseName}
            />
          </NavLink>
        );
      } else if (type === "title") {
        returnValue = (
          <MDTypography
            key={key}
            color={textColor}
            display="block"
            variant="caption"
            fontWeight="bold"
            textTransform="uppercase"
            pl={3}
            mt={2}
            mb={1}
            ml={1}
          >
            {title}
          </MDTypography>
        );
      } else if (type === "divider") {
        returnValue = (
          <Divider
            key={key}
            light={
              (!darkMode && !whiteSidenav && !transparentSidenav) ||
              (darkMode && !transparentSidenav && whiteSidenav)
            }
          />
        );
      }

      return returnValue;
    },
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex === 0 ? 1 : 0)); // Toggle between 0 and 1
    }, 30000); // Switch every 5 seconds

    return () => clearInterval(interval); // Clean up interval on component unmount
  }, []);

  return (
    <SidenavRoot
      {...rest}
      variant="permanent"
      ownerState={{ transparentSidenav, whiteSidenav, miniSidenav, darkMode }}
      id="TheSidenav"
    >
      <MDBox pt={3} pb={1} px={4} textAlign="center">
        <MDBox
          display={{ xs: "block", xl: "none" }}
          position="absolute"
          top={0}
          right={0}
          p={1.625}
          onClick={closeSidenav}
          sx={{ cursor: "pointer" }}
        >
          <MDTypography variant="h6" color="secondary">
            <Icon sx={{ fontWeight: "bold" }}>close</Icon>
          </MDTypography>
        </MDBox>
        <div className="brandContainer">
          <div
            className="slider"
            style={{
              transform: `translateX(${currentIndex === 0 ? "0%" : "-100%"})`, // Slide based on index
            }}
          >
            <div
              className="brandItem"
              onClick={() => navigate("/")} // Navigate to home on click
              style={{ cursor: "pointer" }} // Optional: add pointer cursor for better UX
            >
              {/* Sub-Brand Logo and Name */}
              <img
                style={{ width: "60px", height: "60px" }}
                src={branding?.tenantLogo}
                alt="Sub Brand"
              />
              <h6
                style={{
                  width: "100%",
                  textAlign: "center",
                  overflow: "hidden",
                }}
              >
                {branding?.tenantName}
              </h6>
            </div>

            <div
              className="brandItem"
              onClick={() => navigate("/")} // Navigate to home on click
              style={{ cursor: "pointer" }} // Optional: add pointer cursor for better UX
            >
              {/* Main Brand Logo and Name */}
              <img
                style={{ width: "100px", height: "40px" }}
                src={branding?.FullBrandLogo}
                alt="Main Brand"
              />
              <h6
                style={{
                  width: "100%",
                  textAlign: "center",
                  overflow: "hidden",
                  fontSize: "17px",
                }}
              >
                {branding?.BrandName}
              </h6>
            </div>
          </div>
        </div>
      </MDBox>
      <Divider
        light={
          (!darkMode && !whiteSidenav && !transparentSidenav) ||
          (darkMode && !transparentSidenav && whiteSidenav)
        }
      />

      <List>
        {/* {renderRoutes} */}

        {/* start list */}

        {User.userType === "Patient" && (
          <>
            <Link
              type="button"
              className="activeLabel"
              component={NavLink}
              to="/PatientAccountingSessions/"
            >
              Sessions
            </Link>
            {/* <Link type="button" className="activeLabel" component={NavLink} to="/Users">Appointments</Link> */}
          </>
        )}
        {User.userType === "FloorManager" && (
          <>
            <Link
              type="button"
              className="activeLabel"
              component={NavLink}
              to="/AccountingSessions/"
            >
              Sessions
            </Link>
            <Link
              className="activeLabel"
              component={NavLink}
              to="/Appointments"
            >
              Appointments
            </Link>
          </>
        )}
        {(["Admin", "Owner", "HeadAccounting"].includes(User.userType) ||
          User.userType === "AppointmentEmployee" ||
          User.userType === "CallCenterEmployee" ||
          User.userType === "AccountingEmployee" ||
          User.userType === "SubAdmin") && (
          <>
            <ListItemButton onClick={handleClick0}>
              <ListItemIcon className="header-logo">
                <PersonIcon />
              </ListItemIcon>
              <ListItemText className="headers">
                {translations.sidebarUsermanagement}
              </ListItemText>
              {open0 ? (
                <ExpandLess className="indicator" />
              ) : (
                <ExpandMore className="indicator" />
              )}
            </ListItemButton>

            <Collapse in={open0} timeout="auto" unmountOnExit>
              {/* 1. Manage Users - Visible to everyone listed above */}
              <Link
                type="button"
                className="activeLabel"
                component={NavLink}
                to="/ManageUsers"
              >
                {translations.sidebarChildernManageUsers}
              </Link>
              {["Admin", "Owner", "HeadAccounting"].includes(User.userType) && (
                <Link
                  type="button"
                  className="activeLabel"
                  component={NavLink}
                  to="/CreateUser"
                >
                  {translations.sidebarChildernCreateUsers}
                </Link>
              )}
              <Link
                type="button"
                className="activeLabel"
                component={NavLink}
                to="/CreateClient"
              >
                {translations.sidebarChildernCreateClient}
              </Link>
              <Link
                type="button"
                className="activeLabel"
                component={NavLink}
                to="/PatientHistory"
              >
                {translations.sidebarChildernPatients}
              </Link>
            </Collapse>
          </>
        )}

        {/* administrations */}

        {(["Admin", "Owner", "HeadAccounting"].includes(User.userType) ||
          User.userType === "SubAdmin") && (
          <>
            <ListItemButton onClick={handleClick}>
              <ListItemIcon className="header-logo">
                <SupervisorAccountIcon />
              </ListItemIcon>
              <ListItemText
                className="headers"
                primary={translations.sidebarAdministration}
              />
              {open ? (
                <ExpandLess className="indicator" />
              ) : (
                <ExpandMore className="indicator" />
              )}
            </ListItemButton>

            <Collapse in={open} timeout="auto" unmountOnExit>
              {/* ------------------------  Sessions-------------------------- */}
              <Link className="activeLabel" component={NavLink} to="/Sessions">
                {translations.sidebarChildernAdministrationSessions}
              </Link>
              {(["Admin", "Owner", "HeadAccounting"].includes(User.userType) ||
                User.userType === "SuberAdmin") && (
                <Link
                  type="button"
                  className="activeLabel"
                  component={NavLink}
                  to="/Partitions"
                >
                  {" "}
                  {translations.sidebarChildernPartitions}
                </Link>
              )}
            </Collapse>
          </>
        )}

        {User.userType === "Therapist" && (
          <>
            <Link
              className="activeLabel"
              component={NavLink}
              to="/PatientHistory"
            >
              History Entries
            </Link>
          </>
        )}
        {(User.userType === "AppointmentEmployee" ||
          User.userType === "CallCenterEmployee" ||
          User.userType === "AccountingEmployee" ||
          ["Admin", "Owner", "HeadAccounting"].includes(User.userType) ||
          User.userType === "SubAdmin") && (
          <>
            {/* Accounting */}
            <ListItemButton onClick={handleClick3}>
              <ListItemIcon className="header-logo">
                <AccountBalanceIcon />
              </ListItemIcon>
              <ListItemText
                className="headers"
                primary={translations.sidebarAccounting}
              />
              {open3 ? (
                <ExpandLess className="indicator" />
              ) : (
                <ExpandMore className="indicator" />
              )}
            </ListItemButton>

            <Collapse in={open3} timeout="auto" unmountOnExit>
              {/* ------------------------  Sessions-------------------------- */}
              <Link
                className="activeLabel"
                component={NavLink}
                to="/AccountingSessions"
              >
                {translations.sidebarChildernAccountingAccountingSessions}
              </Link>
              {User.userType != "SubAdmin" && (
                <Link
                  className="activeLabel"
                  component={NavLink}
                  to="/Packages"
                >
                  {translations.sidebarChildernAccountingPackages}
                </Link>
              )}
              {User.userType != "AppointmentEmployee" &&
                User.userType != "CallCenterEmployee" &&
                User.userType != "SubAdmin" && (
                  <>
                    <Link
                      className="activeLabel"
                      component={NavLink}
                      to="/CreatePackage"
                    >
                      {
                        translations.sidebarChildernAccountingCreateMultiPackage
                      }{" "}
                    </Link>
                    {[
                      "Admin",
                      "Owner",
                      "HeadAccounting",
                      "AccountingEmployee",
                    ].includes(User.userType) && (
                      <Link
                        className="activeLabel"
                        component={NavLink}
                        to="/CreateNewAccountingEntry"
                      >
                        {
                          translations.sidebarChildernAccountingCreateAccountingEntry
                        }{" "}
                      </Link>
                    )}
                    {[
                      "Admin",
                      "Owner",
                      "HeadAccounting",
                      "AccountingEmployee",
                    ].includes(User.userType) && (
                      <Link
                        className="activeLabel"
                        component={NavLink}
                        to="/AccountingEntries"
                      >
                        {
                          translations.sidebarChildernAccountingAccountingEntriesTable
                        }{" "}
                      </Link>
                    )}
                    <Link
                      className="activeLabel"
                      component={NavLink}
                      to="/SessionsWithoutEntries"
                    >
                      {
                        translations.sidebarChildernAccountingSessionsWithoutEntries
                      }{" "}
                    </Link>
                    <Link
                      className="activeLabel"
                      component={NavLink}
                      to="/BalanceEntries/"
                    >
                      {
                        translations.sidebarChildernAccountingUserBalanceEntries
                      }{" "}
                    </Link>
                    {/*  <Link
                      className="activeLabel"
                      component={NavLink}
                      to="/CreateInPatientStay"
                    >
                      {
                        translations.sidebarChildernAccountingCreateInPatientStay
                      }{" "}
                    </Link> */}
                    {/* <Link
                      className="activeLabel"
                      component={NavLink}
                      to="/InPatientStays"
                    >
                      {translations.sidebarChildernAccountingInPatientsStays}{" "}
                    </Link> */}

                    <Link
                      className="activeLabel"
                      component={NavLink}
                      to="/CreateContract"
                    >
                      {
                        translations.sidebarChildernAccountingCreateContract
                      }{" "}
                    </Link>
                    <Link
                      className="activeLabel"
                      component={NavLink}
                      to="/ContractTable"
                    >
                      {
                        translations.sidebarChildernAccountingContractsTable
                      }{" "}
                    </Link>
                  </>
                )}
              <>
                <Link className="activeLabel" component={NavLink} to="/Logs">
                  {translations.sidebarChildernAccountingLogs}{" "}
                </Link>
                <Link
                  className="activeLabel"
                  component={NavLink}
                  to="/PatientAnalytics"
                >
                  {translations.sidebarChildernAccountingPatientAnalytics}{" "}
                </Link>
                <Link
                  className="activeLabel"
                  component={NavLink}
                  to="/receipts"
                >
                  {translations.sidebarChildernReceipts}{" "}
                </Link>
              </>
            </Collapse>
          </>
        )}
        {(["Admin", "Owner", "HeadAccounting"].includes(User.userType) ||
          User.userType === "SuperAdmin" ||
          User.userType === "AccountingEmployee") && (
          <>
            <ListItemButton onClick={handleClick6}>
              <ListItemIcon className="header-logo">
                <BuildIcon />
              </ListItemIcon>
              <ListItemText
                className="headers"
                primary={translations.sidebarServices}
              />
              {open6 ? (
                <ExpandLess className="indicator" />
              ) : (
                <ExpandMore className="indicator" />
              )}
            </ListItemButton>

            <Collapse in={open6} timeout="auto" unmountOnExit>
              {/* ------------------------  ManageServices-------------------------- */}
              <Link
                className="activeLabel"
                component={NavLink}
                to="/ManageServices"
              >
                {translations.sidebarChildernServicesManageServices}
              </Link>
            </Collapse>
            <Collapse in={open6} timeout="auto" unmountOnExit>
              <Link
                className="activeLabel"
                component={NavLink}
                to="/NewServiceBundle"
              >
                {translations.sidebarChildernServicesServiceBundle}
              </Link>
            </Collapse>
            <Collapse in={open6} timeout="auto" unmountOnExit>
              <Link
                className="activeLabel"
                component={NavLink}
                to="/ViewServiceBundles"
              >
                {translations.sidebarChildernServicesViewServiceBundles}
              </Link>
            </Collapse>
            <Collapse in={open6} timeout="auto" unmountOnExit>
              <Link
                className="activeLabel"
                component={NavLink}
                to="/BundleReports"
              >
                {translations.sidebarChildernServicesServiceBundlesReports}
              </Link>
            </Collapse>
          </>
        )}
        {(User.userType === "AppointmentEmployee" ||
          User.userType === "CallCenterEmployee" ||
          ["Admin", "Owner", "HeadAccounting"].includes(User.userType) ||
          User.userType === "AccountingEmployee" ||
          User.userType === "Therapist" ||
          User.userType === "SubAdmin") && (
          <>
            {/* Appointments */}
            <ListItemButton onClick={handleClick2}>
              <ListItemIcon className="header-logo">
                <FormatListNumberedIcon />
              </ListItemIcon>
              <ListItemText
                className="headers"
                primary={translations.sidebarAppointments}
              />
              {open2 ? (
                <ExpandLess className="indicator" />
              ) : (
                <ExpandMore className="indicator" />
              )}
            </ListItemButton>

            <Collapse in={open2} timeout="auto" unmountOnExit>
              <Link
                className="activeLabel"
                component={NavLink}
                to="/Appointments"
                end
              >
                {translations.sidebarChildernAppointmentsAppointments}
              </Link>
              <Link
                className="activeLabel"
                component={NavLink}
                to="/AppointmentsBeta"
                end
              >
                {translations.sidebarChildernAppointmentsBeta}
              </Link>
              {/*  <Link
                className="activeLabel"
                component={NavLink}
                to="/PatientPrograms/CreatePatientProgram"
              >
                {translations.sidebarChildernAppointmentsCreatePatientProgram}
              </Link> */}
              {/* <Link
                className="activeLabel"
                component={NavLink}
                to="/ManagePatientPrograms"
              >
                {translations.sidebarChildernAppointmentsManagePatientPrograms}
              </Link> */}
            </Collapse>
          </>
        )}
        {["Admin", "Owner", "HeadAccounting"].includes(User.userType) && (
          <>
            {/* Statistics */}
            <ListItemButton onClick={handleClick5}>
              <ListItemIcon className="header-logo">
                <AnalyticsIcon />
              </ListItemIcon>
              <ListItemText
                className="headers"
                primary={translations.sidebarStatistics}
              />
              {open5 ? (
                <ExpandLess className="indicator" />
              ) : (
                <ExpandMore className="indicator" />
              )}
            </ListItemButton>

            <Collapse in={open5} timeout="auto" unmountOnExit>
              <Link
                className="activeLabel"
                component={NavLink}
                to="/Appointments/Feedback"
              >
                {translations.sidebarChildernStatisticsCreateFeedback}
              </Link>
              <Link
                className="activeLabel"
                component={NavLink}
                to="/Appointments/FeedbackStatistics"
              >
                {translations.sidebarChildernStatisticsFeedbackStatistics}{" "}
              </Link>
              {["Owner", "HeadAccounting"].includes(User.userType) && (
                <>
                  <Link
                    className="activeLabel"
                    component={NavLink}
                    to="/Appointments/AccountingSessionsStatistics"
                  >
                    {" "}
                    {
                      translations.sidebarChildernStatisticsAccountingSessionsStatistics
                    }
                  </Link>
                  <Link
                    className="activeLabel"
                    component={NavLink}
                    to="/Appointments/UserStatistics"
                  >
                    {translations.sidebarChildernStatisticsUsersStatistics}{" "}
                  </Link>
                  <Link
                    className="activeLabel"
                    component={NavLink}
                    to="/Appointments/FinancialPackagesStatistics"
                  >
                    {
                      translations.sidebarChildernStatisticsPackagesStatistics
                    }{" "}
                  </Link>
                  <Link
                    className="activeLabel"
                    component={NavLink}
                    to="/Appointments/PackagesStatistics"
                  >
                    {translations.sidebarChildernStatisticsPackagesStatistics2}
                  </Link>
                  <Link
                    className="activeLabel"
                    component={NavLink}
                    to="/Appointments/AccountingEntriesStatistics"
                  >
                    {" "}
                    {
                      translations.sidebarChildernStatisticsAccountingEntriesStatistics
                    }{" "}
                  </Link>
                </>
              )}
            </Collapse>
          </>
        )}
        {isSuperAdmin && (
          <>
            <ListItemButton onClick={handleClick7}>
              <ListItemIcon className="header-logo">
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText className="headers" primary="Settings" />
              {open7 ? (
                <ExpandLess className="indicator" />
              ) : (
                <ExpandMore className="indicator" />
              )}
            </ListItemButton>

            <Collapse in={open7} timeout="auto" unmountOnExit>
              <Link
                className="activeLabel"
                component={NavLink}
                to="/TenantSettings"
              >
                Tenant Settings
              </Link>
            </Collapse>
          </>
        )}
      </List>
      <MDBox
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        height="54vh"
      >
        <MDBox mt="auto">
          <MDBox display="flex" justifyContent="flex-end" mr="-4" mt="auto">
            <MDBox
              component="a"
              href="https://thedevhouse.web.app/"
              target="_blank"
              className=""
            >
              <MDBox
                width={!brandName && "100%"}
                sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}
              >
                {brand && (
                  <MDBox
                    component="img"
                    src={branding?.BrandLogo}
                    alt="Brand"
                    width="3rem"
                    sx={{
                      marginBottom: "0.6rem",
                      position: "inhert",
                      width: "14rem",
                      marginRight: "-0.1rem",
                      Zindex: 9999,
                    }}
                  />
                )}
              </MDBox>
            </MDBox>
          </MDBox>

          <MDTypography variant="body" color="white" p={2}>
            Language
          </MDTypography>

          <select
            value={language}
            onChange={handleLanguageChange}
            style={{
              backgroundColor: "transparent",
              color: "white",
              fontSize: "15px",
              borderRadius: "4px",
            }}
          >
            {" "}
            <option
              value="en"
              style={{
                color: "black",
                backgroundColor: "white",
                fontSize: "15px",
              }}
            >
              English
            </option>
            <option
              value="ar"
              style={{
                color: "black",
                backgroundColor: "white",
                fontSize: "15px",
              }}
            >
              Arabic
            </option>
          </select>

          {isSuperAdmin && (
            <MDBox p={1} mt="5px" width="100%">
              <MDBox width="100%" textAlign="center">
                <label style={{ color: "white", fontSize: "15px" }}>
                  {currentTenant?.name || "Unknown Tenant"}
                </label>
              </MDBox>
              <MDBox width="100%">
                <select
                  value={selectedTenant}
                  onChange={(e) => setSelectedTenant(e.target.value)}
                  style={{ width: "100%", padding: "8px", fontSize: "15px" }}
                >
                  <option value="">--Select a tenant</option>
                  {Array.isArray(tenants) &&
                    tenants.map((tenant) => (
                      <option key={tenant.id} value={tenant.id}>
                        {tenant.name}
                      </option>
                    ))}
                </select>
              </MDBox>

              <MDBox mt={1} width="100%">
                <MDButton
                  onClick={handleSubmit}
                  disabled={!selectedTenant}
                  fullWidth
                >
                  Submit
                </MDButton>
              </MDBox>
            </MDBox>
          )}

          <MDBox p={1} mt="auto">
            <MDButton
              component="a"
              target="_blank"
              rel="noreferrer"
              sx={{
                backgroundColor: "#3560AD",
                color: "white !important",
                "&:hover": {
                  backgroundColor: "#4682B4",
                  color: "white !important",
                },
              }}
              fullWidth
              onClick={Logout}
            >
              {translations.sidebarLogOutBtn}
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
    </SidenavRoot>
  );
}

// Setting default values for the props of Sidenav
Sidenav.defaultProps = {
  color: "info",
  brand: "",
};

// Typechecking props for the Sidenav
Sidenav.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Sidenav;
